import http from '@/libs/axios'
import {resetState} from "@/store";
import ability from '@/libs/acl/ability'
import { buildAbilityRules } from '@/libs/acl/abilityRules'
import { initialAbility } from '@/libs/acl/config'

export const auth = {
  namespaced: true,
  state: {
    user: {},
    company: {},
    token: null,
    refreshToken: null,
    classifications: [],
    isSuperUser: false,
    superUserCompanies: [],
    countries: [],
    regions: {},
    classifications: [],
    regionalData: null,
    },
  mutations: {
    setAuthState(state, token) {
      state.token = token.access_token
      state.refreshToken = token.refresh_token
      state.user = token.user
      state.isSuperUser = token.is_super_user || false
      state.superUserCompanies = token.companies || []
      ability.update(buildAbilityRules(token.user || {}))
    },
    setAccessToken(state, token) {
      state.token = token
    },
    // eslint-disable-next-line no-unused-vars
    clearAuthState(state) {
      state.token = null
      state.refreshToken = null
      state.isSuperUser = false
      state.superUserCompanies = []
      ability.update(initialAbility)
      resetState()
    },
    setLoggedOut(state) {
      state.token = null
      state.refreshToken = null
      state.isSuperUser = false
      state.superUserCompanies = []
      ability.update(initialAbility)
      resetState()
    },
    removePhoto(state) {
      state.user.photo = null
    },
    updateUser(state, user) {
      state.user = { ...state.user, ...user }
    },
    updateUserPhoto(state, photo) {
      state.user.photo = photo
    },
          setSuperUserCompanies(state, companies) {
        state.superUserCompanies = companies
      },
      setCountries(state, countries) {
        state.countries = countries
      },
      setRegions(state, { countryId, regions }) {
        state.regions = { ...state.regions, [countryId]: regions }
      },
      setClassifications(state, classifications) {
        state.classifications = classifications
      },
      setRegionalData(state, data) {
        state.regionalData = data
      },
    },
  actions: {
    requestReset({ commit }, data) {
      return new Promise((resolve, reject) => {
        http.post('auth/request-password-reset', data).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    logout({ commit }) {
      return new Promise(resolve => {
        http.post('auth/logout').finally(res => {
          resolve(true)
        })
      })
    },
    refreshToken({ state, commit }) {
      return new Promise((resolve, reject) => {
        http.post(`auth/refresh?refresh_token=${state.refreshToken}`).then(res => {
          commit('setAccessToken', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    updateUser({ commit }, data) {
      return new Promise((resolve, reject) => {
        http.put(`auth/update-user/${data.id}`, data).then(res => {
          commit('updateUser', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    updatePassword({ commit }, data) {
      return new Promise((resolve, reject) => {
        http.post('auth/update-password', data).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    removeUserPhoto({ commit }) {
      return new Promise((resolve, reject) => {
        http.post('auth/remove-user-photo').then(res => {
          commit('removePhoto', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    updateUserPhoto({ commit }, data) {
      return new Promise((resolve, reject) => {
        http.post('auth/update-photo', data).then(res => {
          commit('updateUserPhoto', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    switchCompany({ commit }, data) {
      return new Promise((resolve, reject) => {
        http.post('auth/switch-company', data).then(res => {
          commit('setAuthState', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getSuperUserCompanies({ commit }) {
      return new Promise((resolve, reject) => {
        http.get('auth/super-user-companies').then(res => {
          commit('setSuperUserCompanies', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getCountries({ commit }) {
      return new Promise((resolve, reject) => {
        http.get('auth/countries').then(res => {
          commit('setCountries', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getRegions({ commit }, countryId) {
      return new Promise((resolve, reject) => {
        http.get(`auth/regions/${countryId}`).then(res => {
          commit('setRegions', { countryId, regions: res.data })
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    createCompany({ commit }, data) {
      return new Promise((resolve, reject) => {
        http.post('auth/companies', data).then(res => {
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    },
    updateCompanyStatus({ commit }, { companyId, status, inactive_reason, other_inactive_reason }) {
      return new Promise((resolve, reject) => {
        http.put(`auth/companies/${companyId}/status`, { 
          status, 
          inactive_reason, 
          other_inactive_reason 
        }).then(res => {
          resolve(true)
        }).catch(err => {
          reject(err)
        })
      })
    },
    updateCompany({ commit }, { companyId, data }) {
      return new Promise((resolve, reject) => {
        http.put(`auth/companies/${companyId}`, data).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getClassifications({ commit }) {
      return new Promise((resolve, reject) => {
        http.get('system/classifications').then(res => {
          commit('setClassifications', res.data.classifications || [])
          resolve(res.data.classifications || [])
        }).catch(err => {
          reject(err)
        })
      })
    },
    getClassificationsForSuperAdmin({ commit }) {
      return new Promise((resolve, reject) => {
        http.get('system/classifications-for-super-admin').then(res => {
          commit('setClassifications', res.data.classifications || [])
          resolve(res.data.classifications || [])
        }).catch(err => {
          reject(err)
        })
      })
    },
    getRegionalData({ commit }) {
      return new Promise((resolve, reject) => {
        http.get('auth/regional-data').then(res => {
          commit('setRegionalData', res.data)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
  },
  getters: {
    isLoggedIn(state) {
      return !!state.token
    },
    accessToken(state) {
      return state.token
    },
    refreshToken(state) {
      return state.refreshToken
    },
    user(state) {
      return state.user
    },
    isSuperUser(state) {
      return state.isSuperUser
    },
    superUserCompanies(state) {
      return state.superUserCompanies
    },
    countries(state) {
      return state.countries
    },
    regions(state) {
      return state.regions
    },
    classifications(state) {
      return state.classifications
    },
  },
}
